// extracted by mini-css-extract-plugin
export var container = "tabbed-panels-module--container--e993b";
export var panel = "tabbed-panels-module--panel--9fee7";
export var selected = "tabbed-panels-module--selected--634ac";